/* eslint-disable dot-notation */
<template>
  <div
    class="container"
    ref="container"
  >
    <div class="wain">
      <a-icon
        type="info-circle"
        class="wainIcon"
      />
      <p>
        须完成企业认证才可以进行投保。为了不影响您的投标投保，请先完成企业认证！<br>企业认证需在工作日时间（9:00-17:00）内提交。工作日提交当日审核完毕，节假日、非工作日时间内提交的依次顺延审核完毕。
      </p>
    </div>
    <div class="main">
      <PlateTitle title="企业认证" />
    </div>
    <div class="form">
      <a-alert
        message="企业认证信息必须与交易中心投标登记使用的企业信息一致"
        type="warning"
        show-icon
      />
      <a-form
        :form="form"
        :label-col="{ span: 10 }"
        :wrapper-col="{ span: 14 }"
        @submit="handleSubmit"
      >
        <a-form-item label="投标企业名称">
          <a-input
            v-decorator="[
              'companyName',
              { rules: [{ required: true, message: '请输入投标企业名称' }] },
            ]"
            placeholder="请输入投标企业名称"
          />
        </a-form-item>
        <a-form-item label="投标企业统一社会信用代码">
          <div class="creditCode">
            <a-input
              v-decorator="[
                'creditCode',
                {
                  rules: [
                    {
                      required: true,
                      message: '请输入投标企业统一社会信用代码',
                    },
                  ],
                },
              ]"
              placeholder="请输入投标企业统一社会信用代码"
            />
          </div>
        </a-form-item>
        <!-- <a-form-item
          label="不要公司地址"
        >
          <a-input
            v-decorator="['appCompanyAddress', {rules: [{ required: true, message: '请输入公司地址' }] }]"
            placeholder="请输入公司地址"
          />
        </a-form-item>
        <a-form-item
          label="不要公司电话"
        >
          <a-input
            v-decorator="['appCompanyPhone', {rules: [{ required: true, message: '请输入公司电话' }] }]"
            placeholder="请输入公司电话"
          />
        </a-form-item> -->

        <a-form-item label="基本户开户行">
          <a-input
            v-decorator="[
              'basicBankName',
              { rules: [{ required: true, message: '请输入基本户开户行' }] },
            ]"
            placeholder="请输入基本户开户行"
          />
        </a-form-item>
        <a-form-item label="基本户账号">
          <a-input
            v-decorator="[
              'basicNo',
              { rules: [{ required: true, message: '请输入基本户账号' }] },
            ]"
            placeholder="请输入基本户账号"
          />
        </a-form-item>
        <!-- <a-form-item
          label="不要法人姓名"
        >
          <a-input
            v-decorator="['legalPersonName', {rules: [{ required: true, message: '请输入法人姓名' }] }]"
            placeholder="请输入法人姓名"
          />
        </a-form-item>
        <a-form-item
          label="不要法人地址"
        >
          <a-input
            v-decorator="['legalPersonAddress', {rules: [{ required: true, message: '请输入法人地址' }] }]"
            placeholder="请输入法人地址"
          />
        </a-form-item>
        <a-form-item
          label="不要法人手机号"
        >
          <a-input
            v-decorator="['legalPersonPhone', {rules: [{ required: true, message: '请输入法人手机号' }] }]"
            placeholder="请输入法人手机号"
          />
        </a-form-item>
        <a-form-item
          label="不要营业执照编号"
        >
          <a-input
            v-decorator="['businessLicenseCode', {rules: [{ required: true, message: '请输入营业执照编号' }] }]"
            placeholder="请输入营业执照编号"
          />
        </a-form-item> -->
        <!-- <a-form-item
          label="中征码"
        >
          <a-input
            v-decorator="['strikeCode', {rules: [{},],}]"
            placeholder="请输入中征码"
          />
        </a-form-item> -->

        <!-- <a-form-item
          label="不要投保授权书有效期"
        >
          <a-range-picker
            v-decorator="['identifyExpiry', {rules: [{type: 'array', required: true, message: '请选择授权书有效期' }]}]"
            format="YYYY-MM-DD"
            :locale="locale"
          />
        </a-form-item>

        <a-form-item
          label="不要营业执照有效期"
        >
          <div class="picker">
            <a-date-picker
              placeholder="请选择日期"
              @change="changeStartDate"
              v-decorator="['busLicenseStart', {rules: [{ required: true, message: '请输入营业执照有效期' }] }]"
            />至
            <a-date-picker
              v-show="!longTerm"
              @change="changeEndDate"
              placeholder="请选择日期"
              :value="busLicenseEnd"
            />
            <a-date-picker
              id="busLicenseEnd"
              :default-value="moment('2099-12-31', 'YYYY-MM-DD')"
              v-show="longTerm"
              disabled
            />
            <a-checkbox
              class="checkbox"
              @change="onChange"
            >
              长期
            </a-checkbox>
          </div>
          <div
            id="validator"
            style="color:red;display:none"
          >
            请选择营业执照有效期
          </div>
        </a-form-item> -->

        <a-form-item label="基本户影像文件上传">
          <span class="ant-form-text">
            支持jpg、png格式文件，文件不能大于5M
          </span>
          <a-upload
            action="/lianyungang-platform/fileApi/upload"
            :data="{ fileUrl: 'entCertForm' }"
            v-decorator="[
              'basicImage',
              {
                rules: [
                  {
                    required: true,
                    validator: uploadValidator,
                    trigger: 'blur',
                  },
                ],
              },
            ]"
            list-type="picture-card"
            :file-list="basicImage"
            @preview="handlePreview"
            :before-upload="beforeUpload"
            @change="handleChangeBasic"
            :remove="
              () => {
                basicImage.pop();
              }
            "
          >
            <div v-if="basicImage.length < 1">
              <a-icon type="plus" />
            </div>
          </a-upload>
          <a-modal
            :visible="previewVisible"
            :footer="null"
            @cancel="handleCancel"
          >
            <img
              alt="example"
              style="width: 100%"
              :src="previewImage"
            >
          </a-modal>
        </a-form-item>

        <a-form-item label="企业营业执照（加盖公章）">
          <span class="ant-form-text">
            请提供扫描件。支持jpg、png格式文件，文件不能大于5M
          </span>
          <a-upload
            action="/lianyungang-platform/fileApi/upload"
            v-decorator="[
              'businessFile',
              {
                rules: [
                  {
                    required: true,
                    validator: uploadValidator,
                    trigger: 'blur',
                  },
                ],
              },
            ]"
            :data="{ fileUrl: 'entCertForm' }"
            list-type="picture-card"
            :file-list="businessFile"
            @preview="handlePreview"
            :before-upload="beforeUpload"
            @change="handleChangeBusiness"
            :remove="
              () => {
                businessFile.pop();
              }
            "
          >
            <div v-if="businessFile.length < 1">
              <a-icon type="plus" />
            </div>
          </a-upload>
          <a-modal
            :visible="previewVisible"
            :footer="null"
            @cancel="handleCancel"
          >
            <img
              alt="example"
              style="width: 100%"
              :src="previewImage"
            >
          </a-modal>
        </a-form-item>

        <!-- <a-form-item
          label="投保授权书"
        >
          <span class="ant-form-text">
            请提供扫描件。支持jpg、png格式文件，文件不能大于5M
          </span>
          <a href="https://zbsz-guarantee-prod.oss-cn-hangzhou.aliyuncs.com/lianyungang/common/hubContract/%E4%BC%81%E4%B8%9A%E6%8E%88%E6%9D%83%E5%A7%94%E6%89%98%E4%B9%A6_%E6%A8%A1%E6%9D%BF.docx">
            (企业授权委托书_模板下载)
          </a>
          <a-upload
            action="/lianyungang-platform/fileApi/upload"
            v-decorator="['certificateLicense', {rules: [{ required: true, validator:uploadValidator, trigger: 'blur' }]}]"
            :data="{'fileUrl':'entCertForm'}"
            list-type="picture-card"
            :file-list="certificateLicense"
            @preview="handlePreview"
            :before-upload="beforeUpload"
            @change="handleChangeCertificate"
            :remove="()=>{certificateLicense.pop()}"
          >
            <div v-if="certificateLicense.length < 1">
              <a-icon type="plus" />
            </div>
          </a-upload>
          <a-modal
            :visible="previewVisible"
            :footer="null"
            @cancel="handleCancel"
          >
            <img
              alt="example"
              style="width: 100%"
              :src="previewImage"
            >
          </a-modal>
        </a-form-item>

        <a-form-item
          label="法人身份证（加盖公章）"
        >
          <span class="ant-form-text">
            请提供正反面扫描件。支持jpg、png格式文件，文件不能大于5M
          </span>
          <a-upload
            action="/lianyungang-platform/fileApi/upload"
            v-decorator="['legalFile', {rules: [{ required: true, validator:uploadValidator, trigger: 'blur' }]}]"
            :data="{'fileUrl':'entCertForm'}"
            list-type="picture-card"
            :file-list="legalFile"
            @preview="handlePreview"
            :before-upload="beforeUpload"
            @change="handleChangeLegal"
            :remove="()=>{legalFile.pop()}"
          >
            <div v-if="legalFile.length < 2">
              <a-icon type="plus" />
            </div>
          </a-upload>
          <a-modal
            :visible="previewVisible"
            :footer="null"
            @cancel="handleCancel"
          >
            <img
              alt="example"
              style="width: 100%"
              :src="previewImage"
            >
          </a-modal>
        </a-form-item>
        <a-form-item
          label="授权人身份证"
        >
          <span class="ant-form-text">
            请提供正反面扫描件。支持jpg、png格式文件，文件不能大于5M
          </span>
          <a-upload
            action="/lianyungang-platform/fileApi/upload"
            v-decorator="['authPersonFile', {rules: [{ required: true, validator:uploadValidator, trigger: 'blur' }]}]"
            :data="{'fileUrl':'entCertForm'}"
            list-type="picture-card"
            :file-list="authPersonFile"
            @preview="handlePreview"
            :before-upload="beforeUpload"
            @change="handleChangeAuth"
            :remove="()=>{authPersonFile.pop()}"
          >
            <div v-if="authPersonFile.length < 2">
              <a-icon type="plus" />
            </div>
          </a-upload>
          <a-modal
            :visible="previewVisible"
            :footer="null"
            @cancel="handleCancel"
          >
            <img
              alt="example"
              style="width: 100%"
              :src="previewImage"
            >
          </a-modal>
        </a-form-item>
        <a-form-item
          label="资质证书"
        >
          <span class="ant-form-text">
            请提供扫描件。支持jpg、png、pdf格式文件，文件不能大于5M
          </span>
          <a-upload
            action="/lianyungang-platform/fileApi/upload"
            v-decorator="['certifications', {rules: [{ required: true, validator:uploadValidator, trigger: 'blur' }]}]"
            :data="{'fileUrl':'entCertForm'}"
            list-type="picture-card"
            :file-list="certifications"
            @preview="handlePreview"
            :before-upload="beforeUpload"
            @change="handleChangeCert"
            :remove="()=>{certifications.pop()}"
          >
            <div v-if="certifications.length < 1">
              <a-icon type="plus" />
            </div>
          </a-upload>
          <a-modal
            :visible="previewVisible"
            :footer="null"
            @cancel="handleCancel"
          >
            <img
              alt="example"
              style="width: 100%"
              :src="previewImage"
            >
          </a-modal>
        </a-form-item> -->
        <a-form-item
          :wrapper-col="{ span: 12, offset: 10 }"
          class="entBtn"
        >
          <a-button
            type="primary"
            html-type="submit"
          >
            确定并进入下一步
          </a-button>
        </a-form-item>
      </a-form>
    </div>
    <!-- <a-modal
      title="登录CA证书"
      :visible="visible"
      @ok="handleCA"
      @cancel="handleDown"
      cancel-text="取消"
      ok-text="CA登录"
      :get-container="()=>$refs.container"
    >
      <a-spin
        :spinning="spinAddress"
      >
        <div class="CAcode">
          <div class="CAlogin">
            <a-icon type="exclamation-circle" />
            <div>请登录您的CA证书，如为泰州颁发的CA证书，无需进行人工审核；<br>如为其他机构颁发的CA证书，人工审核将在1-2个工作日完成</div>
          </div>
          <div>
            <span v-if="caFlag === '-1'">未检测到您的CA证书，请再次尝试或<a @click="handleDown">点击确认</a>进入人工审核</span>
            <span v-if="caFlag === '0'">检测到您登录为非泰州颁发的证书或证书信息不全，<a @click="handleDown">点击确认</a>进入人工审核</span>
            <span v-if="caFlag === '1'">恭喜您，检测到您登录的为泰州颁发的证书，系统自动审核通过，{{ time }}秒后跳转至账户管理</span>
          </div>
        </div>
      </a-spin>
    </a-modal> -->
    <a-modal
      title="信息认证"
      :visible="visibleMsg"
      @ok="msgOk"
      @cancel="msgDown"
      cancel-text="取消"
      ok-text="确认"
      :get-container="() => $refs.container"
    >
      <!-- 地址 -->
      <a-spin :spinning="spinAddress">
        <div class="CAcode">
          <div class="CAlogin">
            <a-icon type="exclamation-circle" />
            <div>企业认证信息必须与交易中心投标登记使用的企业信息一致</div>
          </div>
        </div>
      </a-spin>
    </a-modal>
  </div>
</template>

<script>
import PlateTitle from '@/components/PlateTitle';
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
moment.locale('zh-cn');
import { submitApproveInfo } from '@/api/entCertification/entCertification.js';
import { entInfo } from '@/api/entCertification/entCertification.js';
// import { dateFormatDay } from '@/utils/format.js';
// import { message } from 'ant-design-vue';
function getBase64(file) {
  // const reader = new FileReader();
  // reader.readAsDataURL(file);
  // reader.onload = () => reader.result;
  // reader.onerror = error => message.error(error);
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });
}
// eslint-disable-next-line no-unused-vars
let beforePath = '';

export default {
  name: 'EntCertForm',
  components: {
    PlateTitle,
  },
  data() {
    return {
      longTerm: false,
      // busLicenseStart: null,
      // busLicenseEnd: null,
      time: 2,
      timer: '',
      caFlag: '',
      spinAddress: false,
      visible: true,
      visibleMsg: false,
      locale,
      // form: this.$form.createForm(this, { name: 'coordinated' }),
      previewVisible: false,
      previewImage: '',
      file: {},
      businessFile: [],
      basicImage: [],
      // certificateLicense: [],
      // legalFile: [],
      // authPersonFile: [],
      // certifications: [],
      validatorObj: {
        businessFile: '',
        basicImage: '',
        // certificateLicense: '',
        // legalFile: '',
        // authPersonFile: '',
        // certifications: '',
      },
      companyInfo: {
        caFlag: '',
        companyName: '',
        creditCode: '',
      },
      uploadTranslate: {
        basicImage: '基本户影像文件',
        businessFile: '企业营业执照',
        // certificateLicense: '投保授权书',
        // legalFile: '法人身份证',
        // authPersonFile: '授权人身份证',
        // certifications: '资质证书',
      },
    };
  },
  // watch: {
  //   busLicenseStart(val) {
  //     if (val === '') {
  //       document.getElementById('validator').style.display = 'none';
  //     }
  //   },
  //   busLicenseEnd(val) {
  //     if (val !== '') {
  //       document.getElementById('validator').style.display = 'none';
  //     } else {
  //       document.getElementById('validator').style.display = 'block';
  //     }
  //   },
  //   longTerm(val) {
  //     if (!val && this.busLicenseEnd === '') {
  //       document.getElementById('validator').style.display = 'block';
  //     }
  //     if (val) {
  //       document.getElementById('validator').style.display = 'none';
  //     }
  //   },
  //   immediate: true,
  // },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'coordinated' });
  },
  created() {
    this.entInfo();
  },
  beforeRouteEnter(to, from, next) {
    beforePath = from; // path为定义的变量，不是vue的data定义的变量，当前生命周期data还未初始化
    next();
  },
  mounted() {
    console.log(beforePath);
    if (this.$route.query && this.$route.query.companyInfo) {
      const companyInfo = JSON.parse(
        decodeURIComponent(this.$route.query.companyInfo)
      );
      this.companyInfo = { ...companyInfo };
      this.caFlag = this.companyInfo.caFlag;
      this.$nextTick(() => {
        this.form.setFieldsValue({
          companyName: this.companyInfo.companyName
            ? this.companyInfo.companyName
            : '',
          creditCode: this.companyInfo.certCode
            ? this.companyInfo.certCode
            : '',
        });
      });
      if (this.companyInfo.caFlag === '1') {
        this.timer = setInterval(this.countDown, 1000);
      }
    }
  },
  methods: {
    moment,
    // changeStartDate(date, dateString) {
    //   this.busLicenseStart = dateString;
    //   // console.log(date, dateString);
    // },
    // changeEndDate(date, dateString) {
    //   this.busLicenseEnd = dateString;
    // },
    entInfo() {
      entInfo().then(res => {
        const data = res.data.data;
        if (data.identifyStart === null) {
          delete data.identifyStart;
        }
        if (data.identifyExpiry === null) {
          delete data.identifyExpiry;
        }
        setTimeout(() => {
          this.form.setFieldsValue({
            companyName: data.companyName,
            creditCode: data.creditCode,
            // appCompanyAddress: data.appCompanyAddress,
            // appCompanyPhone: data.appCompanyPhone,
            basicBankName: data.basicBankName,
            basicNo: data.basicNo,
            // legalPersonName: data.legalPersonName,
            // legalPersonAddress: data.legalPersonAddress,
            // legalPersonPhone: data.legalPersonPhone,
            // businessLicenseCode: data.businessLicenseCode,
            // strikeCode: data.strikeCode,
            // identifyExpiry: [ moment(dateFormatDay(data.identifyStart), 'YYYY-MM-DD'), moment(dateFormatDay(data.identifyExpiry), 'YYYY-MM-DD') ],
            // busLicenseStart: data.busLicenseStart !== null ? moment(dateFormatDay(data.busLicenseStart), 'YYYY-MM-DD') : '',
          });
          // this.busLicenseEnd = data.busLicenseEnd !== null ? moment(dateFormatDay(data.busLicenseEnd), 'YYYY-MM-DD') : '';
          // this.busLicenseStart = data.busLicenseStart !== null ? moment(dateFormatDay(data.busLicenseStart), 'YYYY-MM-DD') : '';
        }, 0);
        if (data.legalPersonCardImage !== null) {
          this.file = {
            businessFile: data.businessLicenseImage,
            // certifications: data.certifications,
            basicImage: data.basicImage,
            // certificateLicense: data.certificateLicense,
            // legalFile: data.legalPersonCardImage.split(','),
            // authPersonFile: data.authorizerCardImage.split(','),
          };

          if (this.file.businessFile !== null) {
            this.businessFile = [
              {
                uid: '001',
                name: 'image.png',
                status: 'done',
                url:
                  '/lianyungang-platform/fileApi/read?filePath=' +
                  data.businessLicenseImage,
              },
            ];
          }
          if (this.file.basicImage !== null) {
            this.basicImage = [
              {
                uid: '002',
                name: 'image.png',
                status: 'done',
                url:
                  '/lianyungang-platform/fileApi/read?filePath=' +
                  data.basicImage,
              },
            ];
          }
          // if (this.file.certificateLicense !== null) {
          //   this.certificateLicense = [{
          //     uid: '003',
          //     name: 'image.png',
          //     status: 'done',
          //     url: '/lianyungang-platform/fileApi/read?filePath=' + data.certificateLicense,
          //   }];
          // }
          // if (this.file.legalFile !== null) {
          //   this.legalFile = [{
          //     uid: '004',
          //     name: 'image.png',
          //     status: 'done',
          //     url: '/lianyungang-platform/fileApi/read?filePath=' + data.legalPersonCardImage.split(',')[0],
          //   }, {
          //     uid: '005',
          //     name: 'image.png',
          //     status: 'done',
          //     url: '/lianyungang-platform/fileApi/read?filePath=' + data.legalPersonCardImage.split(',')[1],
          //   }];
          // }
          // if (this.file.authPersonFile !== null) {
          //   this.authPersonFile = [{
          //     uid: '006',
          //     name: 'image.png',
          //     status: 'done',
          //     url: '/lianyungang-platform/fileApi/read?filePath=' + data.authorizerCardImage.split(',')[0],
          //   }, {
          //     uid: '007',
          //     name: 'image.png',
          //     status: 'done',
          //     url: '/lianyungang-platform/fileApi/read?filePath=' + data.authorizerCardImage.split(',')[1],
          //   }];
          // }
          // if (this.file.certifications !== null) {
          //   this.certifications = [{
          //     uid: '008',
          //     name: 'image.png',
          //     status: 'done',
          //     url: '/lianyungang-platform/fileApi/read?filePath=' + data.certifications,
          //   }];
          // }
          // 定义个校验对象，用于自定义校验
          this.validatorObj = {
            businessFile: this.businessFile,
            basicImage: this.basicImage,
            // certificateLicense: this.certificateLicense,
            // legalFile: this.legalFile,
            // authPersonFile: this.authPersonFile,
            // certifications: this.certifications,
          };
        }
      });
    },
    onChange(e) {
      this.longTerm = e.target.checked;
      console.log(`checked = ${e.target.checked}`);
    },
    handleChangeBasic({ fileList }) {
      this.basicImage = fileList;
    },
    handleChangeBusiness({ fileList }) {
      this.businessFile = fileList;
    },
    // handleChangeCertificate({ fileList }) {
    //   this.certificateLicense = fileList;
    // },
    // handleChangeLegal({ fileList }) {
    //   this.legalFile = fileList;
    // },
    // handleChangeAuth({ fileList }) {
    //   this.authPersonFile = fileList;
    // },
    // handleChangeCert({ fileList }) {
    //   this.certifications = fileList;
    // },
    countDown() {
      if (this.time > 0) {
        this.time--;
      } else {
        this.time = 0;
        this.visible = false;
        clearInterval(this.timer);
        this.$router.push({ name: 'user' });
      }
    },
    handleDown() {
      this.visible = false;
    },
    msgOk() {
      // const {
      //   form: { validateFields },
      // } = this;
      this.form.validateFields((err, values) => {
        // eslint-disable-next-line dot-notation
        // console.log('err：' + err, 'values:' + values['identifyExpiry'], '影像：' + values['basicImage']);
        // if (!this.longTerm && this.busLicenseEnd === '' && this.busLicenseStart !== '') {
        //   this.visibleMsg = false;
        //   this.$message.error('请填写营业执照有效期');
        //   document.getElementById('validator').style.display = 'block';
        //   return;
        // }
        if (!err) {
          const info = this.$store.state.info;
          this.businessFile.forEach(item => {
            if (item.response) {
              this.file.businessFile = item.response.data.serverName;
            }
          });
          this.basicImage.forEach(item => {
            if (item.response) {
              this.file.basicImage = item.response.data.serverName;
            }
          });
          // this.certificateLicense.forEach(item => {
          //   if (item.response) {
          //     this.file.certificateLicense = item.response.data.serverName;
          //   }
          // });
          // this.certifications.forEach(item => {
          //   if (item.response) {
          //     this.file.certifications = item.response.data.serverName;
          //   }
          // });

          // if (!this.file.legalFile) {
          //   this.file.legalFile = [];
          // }
          // this.legalFile.forEach((item, index) => {
          //   if (item.response) {
          //     this.file.legalFile[index] = item.response.data.serverName;
          //   }
          // });
          // if (!this.file.authPersonFile) {
          //   this.file.authPersonFile = [];
          // }
          // this.authPersonFile.forEach((item, index) => {
          //   if (item.response) {
          //     this.file.authPersonFile[index] = item.response.data.serverName;
          //   }
          // });
          console.log(this.longTerm);
          const params = {
            customerId: info.id,
            companyName: values.companyName,
            creditCode: values.creditCode,
            // appCompanyAddress: values.appCompanyAddress,
            // appCompanyPhone: values.appCompanyPhone,
            basicBankName: values.basicBankName,
            basicNo: values.basicNo,
            // legalPersonName: values.legalPersonName,
            // legalPersonAddress: values.legalPersonAddress,
            // legalPersonPhone: values.legalPersonPhone,
            // businessLicenseCode: values.businessLicenseCode,
            // strikeCode: values.strikeCode,
            // eslint-disable-next-line dot-notation
            // identifyStart: values['identifyExpiry'][0].format('YYYY-MM-DD'),
            // eslint-disable-next-line dot-notation
            // identifyExpiry: values['identifyExpiry'][1].format('YYYY-MM-DD'),
            // busLicenseStart: this.busLicenseStart,
            // busLicenseEnd: this.longTerm ? '2099-12-31' : this.busLicenseEnd,
            businessLicenseImage: this.file.businessFile,
            basicImage: this.file.basicImage,
            // certificateLicense: this.file.certificateLicense,
            // certifications: this.file.certifications,
            // legalPersonCardImage: this.file.legalFile.join(','),
            // authorizerCardImage: this.file.authPersonFile.join(','),
            // businessLicenseImage: businessLicenseImage.join(','),
            // legalPersonCardImage: legalPersonCardImage.join(','),
            // authorizerCardImage: authorizerCardImage.join(','),
            certificationFlag: info.certificationFlag,
          };
          submitApproveInfo(params)
            .then(res => {
              if (res.data.status === 'FAIL') {
                this.$message.warning(res.data.errorMsg);
              } else {
                this.$message.success('企业认证提交成功');
                // if (beforePath.name === 'Project') {
                //   this.$router.push({ path: `${beforePath.fullPath}` });
                //   return;
                // }
                this.$router.push({ name: 'entCertification' });
              }
            })
            .catch(err => {
              // this.$message.error('系统繁忙，请联系管理员');
              console.error('接口请求错误', err);
            });
        } else {
          this.visibleMsg = false;
          this.$message.error('表单校验错误，请检查你的企业认证信息');

          console.error('表单校验错误：', err);
        }
      });
    },
    msgDown() {
      this.visibleMsg = false;
    },
    // 下一步
    handleSubmit(e) {
      this.visibleMsg = true;
      e.preventDefault();
    },
    // 取消预览
    handleCancel() {
      this.previewVisible = false;
    },
    // 预览
    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      this.previewImage = file.url || file.preview;
      this.previewVisible = true;
    },
    // 上传图片前的钩子函数
    beforeUpload(file) {
      console.log(file);
      // return new Promise(async (resolve, reject) => {
      if (!file.type.includes('image')) {
        this.$message.warning('请上传正确格式图片');
        // reject(new Error('请上传图片'));
        return false;
      }
      this.isShowSpinning = true;
      this.compressImg(file).then(res => {
        res.uid = file.uid;
        return res;
      });
    },
    // base64转码（压缩完成后的图片为base64编码，这个方法可以将base64编码转回file文件）
    dataURLtoFile(dataurl, filename) {
      const arr = dataurl.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([ u8arr ], filename, { type: mime });
    },
    // 图片压缩函数
    compressImg(file) {
      const that = this;
      const fileSize = parseFloat(parseInt(file.size) / 1024 / 1024).toFixed(2);
      const read = new FileReader();
      read.readAsDataURL(file);
      return new Promise(function(resolve) {
        read.onload = function(e) {
          const img = new Image();
          img.src = e.target.result;
          img.onload = function() {
            // 默认按比例压缩
            const w = this.width;
            const h = this.height;
            // 生成canvas
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');
            let base64;
            // 创建属性节点
            canvas.setAttribute('width', w);
            canvas.setAttribute('height', h);
            ctx.drawImage(this, 0, 0, w, h);
            if (fileSize < 1) {
              // 如果图片小于一兆 那么压缩0.5
              base64 = canvas.toDataURL(file.type, 0.5);
            } else if (fileSize > 1 && fileSize < 2) {
              // 如果图片大于1M并且小于2M 那么压缩0.5
              base64 = canvas.toDataURL(file.type, 0.5);
            } else {
              // 如果图片超过2m 那么压缩0.2
              base64 = canvas.toDataURL(file.type, 0.2);
            }
            // 回调函数返回file的值（将base64编码转成file）
            const files = that.dataURLtoFile(base64, file.name); // 如果后台接收类型为base64的话这一步可以省略
            resolve(files);
          };
        };
      });
    },
    uploadValidator(rule, value, callback) {
      const twoFiles = [ 'legalFile', 'authPersonFile' ];
      const isTwo = twoFiles.some(item => item === rule.field);
      // console.log(' this.validatorObj' + Object.keys(this.validatorObj));
      const objLength = this.validatorObj[rule.field].length;
      if (typeof value === 'undefined' || value === '') {
        if (objLength < 1 && !isTwo) {
          callback(new Error(`请上传${this.uploadTranslate[rule.field]}`));
        } else if (objLength < 2 && isTwo) {
          callback(new Error('文件未上传完善'));
        }
        callback();
      } else {
        value.fileList.forEach(item => {
          if (item.status !== 'done') {
            callback(new Error('该文件未上传成功'));
          }
        });
        if (isTwo && value.fileList.length < 2) {
          callback(new Error('文件未上传完善'));
        }
        callback();
      }
    },
    // 上传
    /*     handleChange(type, { fileList }) {
      console.log(type, fileList);
      if (type === 'business') {
        if (fileList.length > this.businessFile.length) {
          if (!(fileList[fileList.length - 1].type === 'image/jpeg' || fileList[fileList.length - 1].type === 'image/png')) {
            this.$message.warning('请上传正确格式的文件。');
            return false;
          }
        }
        this.businessFile = fileList;
      } else if (type === 'legal') {
        if (fileList.length > this.legalFile.length) {
          if (!(fileList[fileList.length - 1].type === 'image/jpeg' || fileList[fileList.length - 1].type === 'image/png')) {
            this.$message.warning('请上传正确格式的文件。');
            return false;
          }
        }
        this.legalFile = fileList;
      } else if (type === 'authPerson') {
        if (fileList.length > this.authPersonFile.length) {
          if (!(fileList[fileList.length - 1].type === 'image/jpeg' || fileList[fileList.length - 1].type === 'image/png')) {
            this.$message.warning('请上传正确格式的文件。');
            return false;
          }
        }
        this.authPersonFile = fileList;
      } else if (type === 'basicImage') {
        if (fileList.length > this.basicImage.length) {
          if (!(fileList[fileList.length - 1].type === 'image/jpeg' || fileList[fileList.length - 1].type === 'image/png')) {
            this.$message.warning('请上传正确格式的文件。');
            return false;
          }
        }
        this.basicImage = fileList;
      } else if (type === 'certificateLicense') {
        if (fileList.length > this.certificateLicense.length) {
          if (!(fileList[fileList.length - 1].type === 'image/jpeg' || fileList[fileList.length - 1].type === 'image/png')) {
            this.$message.warning('请上传正确格式的文件。');
            return false;
          }
        }
        this.certificateLicense = fileList;
      } else if (type === 'certifications') {
        if (fileList.length > this.certifications.length) {
          const fileType = fileList[fileList.length - 1].type;
          if (!(fileType === 'application/pdf' || fileType === 'image/jpeg' || fileType === 'image/png')) {
            this.$message.warning('请上传正确格式的文件。');
            return false;
          }
        }
        this.certifications = fileList;
      }
    }, */
  },
};
</script>
<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
}
.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.checkbox {
  margin-left: 10px;
}
/deep/ .picker .ant-calendar-picker-input {
  width: 156px !important;
}
.ant-upload-select-picture-card {
  margin-top: 8px;
  color: #666;
}
.container {
  background-color: #fff;
  margin: 30px auto;
  min-height: 700px;
  display: flex;
  flex-direction: column;

  /deep/ .ant-modal-header {
    border: none;
  }
  /deep/ .ant-modal-footer {
    border: none;
    height: 76px;
    background-color: #f7faff;
  }
  /deep/ .ant-modal-body {
    padding: 0 24px;
  }
  /deep/ .ant-spin-container {
    padding-top: 40px;
    padding-bottom: 64px;
    border-top: 1px solid #ebf2f7;
  }
  /deep/ .ant-btn {
    width: 100px;
    height: 36px;
    border-radius: 3px;
    border: 1px solid #007ce2;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    margin-top: 10px;
    color: #007ce2;
  }
  /deep/ .ant-btn-primary {
    background: #007ce2;
    color: #fff;
    margin-right: 14px;
    margin-left: 20px;
  }
}
.wain {
  width: 1100px;
  height: 70px;
  background: #fffbf3;
  margin: 0 auto;
  margin-top: 30px;
  position: relative;
  .wainIcon {
    position: absolute;
    top: 16px;
    left: 30px;
    width: 12px;
    height: 12px;
    color: #e7b24b;
  }
  p {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #e7b24b;
    margin: 12px;
    margin-left: 53px;
  }
}
.main {
  padding: 40px 0px 20px;
  border-bottom: 1px solid #ebf2f7;
  width: 1100px;
  margin: auto;
}
.form {
  margin-top: 20px;
  /deep/ .ant-alert-warning {
    width: 500px;
    padding: 8px;
    color: #999;
    margin: 0 auto;
    padding-left: 35px;
    span {
      color: #666;
    }
  }
  /deep/ .ant-upload {
    width: 80px;
    height: 80px;
  }
  /deep/ .ant-form-item {
    margin: 20px 0;
    span {
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #999999;
    }
    .creditCode {
      display: flex;
      flex-direction: column;
    }
    .same {
      line-height: 14px;
      margin-top: 7px;
    }
  }
  /deep/ .ant-form-item label {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #666666;
    margin-right: 10px;
  }
  /deep/ .ant-input {
    width: 330px;
    height: 36px;
    background: #ffffff;
    border: 1px solid #e1e8ef;
    border-radius: 3px;
    padding-left: 8px;
  }
  /deep/ .ant-btn {
    width: 200px;
    height: 44px;
    background: #007ce2;
    border-radius: 4px;
    margin: 40px 0;
    margin-bottom: 60px;
    span {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
    }
  }
  .entBtn {
    border-top: 1px solid #ebf2f7;
    width: 1080px;
    margin: 0 auto;
  }
}
.CAcode {
  .CAlogin {
    display: flex;
    background: #fffbf3;
    margin: 0 auto;
    position: relative;
    .anticon {
      position: absolute;
      width: 14px;
      height: 14px;
      color: #e7b24b;
      top: 14px;
      left: 10px;
    }
    div {
      padding: 10px 0px 9px 33px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #e7b24b;
    }
  }
  /deep/ .ant-input {
    width: 330px;
    height: 36px;
    background: #ffffff;
    border: 1px solid #e1e8ef;
    border-radius: 3px;
    padding-left: 8px;
    margin: 15px 0;
  }
}
</style>
